import React from 'react';
import './FounderStory.css';
import Container from './Container'
const FounderStory = () => {
  return (
    <section className="founder-story-section">
      <Container>
      <div className="founder-story-container">
        <h2>Founder's Story</h2>
        
        <div className="founder-story-content">
          <p>
            The idea for this company originated from a near-death medical emergency. This individual 
            followed the commercial strategies at the time by leaving a copy at the emergency contact 
            numbers or resided on the end table at the entry foyer. The individual in distress had updated 
            contact numbers and the end table at the entry foyer though, it to be easily accessible and thought 
            at the time to be logically located. EMT personnel responding focused on stabilizing the patient 
            and readying for transport. There was minimal time for EMT to look for emergency contact 
            information. During a panic search, unfortunately, medical emergency documents were not 
            located. The Hospital was required to name the individual (not by kin for someone to approve 
            and authorize treatment proved difficult and became a race against the clock. Fortunately, the 
            founder survived and the necessity for ELDR (Electronic Legal Document Repository) became a reality.
          </p>
        </div>
      </div>
      </Container>
    </section>
  );
};

export default FounderStory;
